import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Cv from '../views/Cv.vue'
import Tips from '../views/Tips.vue'
import Maps from '../views/Maps.vue'
import Photos from '../views/Photos.vue'
import Andoras from '../views/Andoras.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/cv/',
    name: 'Cv',
    component: Cv
  },
  {
    path: '/astuces/',
    name: 'Tips',
    component: Tips
  },
  {
    path: '/voyages/',
    name: 'Maps',
    component: Maps
  },
  {
    path: '/photos/',
    name: 'Photos',
    component: Photos
  },
  {
    path: '/andoras/',
    name: 'Andoras',
    component: Andoras
  },
]

const router = new VueRouter({
  routes
})

export default router
